import { push } from 'connected-react-router';

// eslint-disable-next-line import/no-cycle
import * as AuthService from '../../services/AuthServices';
import {
  DEFAULT_PRIVATE_ROUTE, DEFAULT_PUBLIC_ROUTE, MANUFACTURERS_HOME, VENDORS_HOME,
} from '../../app/components/Routes/constants';
import { stringArrayToObject } from '../../utils/array';

import { actionCreators as appActions } from '../Application/actions';
import { actionCreators as toastActions } from '../Toasts/actions';

import I18next from '../../config/i18n';

import { TYPE_MANUFACTURER } from '../../utils/plans';

/* ------------- Auth actions ------------- */
export const actions = stringArrayToObject(
  [
    'LOGIN',
    'LOGIN_SUCCESS',
    'LOGIN_FAILURE',
    'RECOVER_PASSWORD',
    'RESET_PASSWORD',
    'LOGOUT',
    'LOGOUT_END',
    'AUTH_INIT',
    'REGISTER',
    'REGISTER_SUCCESS',
    'REGISTER_FAILURE',
  ],
  '@@AUTH',
);

const privateActionCreators = {
  loginSuccess(authData) {
    return {
      type: actions.LOGIN_SUCCESS,
      payload: { authData },
    };
  },
  loginFailure(err) {
    return {
      type: actions.LOGIN_FAILURE,
      payload: { err },
    };
  },
  registerStart() {
    return {
      type: actions.REGISTER,
    };
  },
  registerSuccess() {
    return {
      type: actions.REGISTER_SUCCESS,
    };
  },
  registerFailure(err) {
    return {
      type: actions.REGISTER_FAILURE,
      payload: { err },
    };
  },
};

export const actionCreators = {
  init(user) {
    return {
      type: actions.AUTH_INIT,
      payload: { user },
    };
  },
  refresh() {
    return async (dispatch) => {
      const response = await AuthService.refresh();
      if (response.ok) {
        dispatch(actionCreators.init(response.user));
        if (response.user) {
          const responsePermissions = await AuthService.myPermissions();
          dispatch(actionCreators.init({
            ...response.user,
            permissions: responsePermissions.data,
          }));
        }
      }
      dispatch(appActions.init());
    };
  },
  login(authData) {
    return async (dispatch) => {
      dispatch({ type: actions.LOGIN });
      if (authData) {
        const response = await AuthService.login(authData);
        const responsePermissions = await AuthService.myPermissions();
        if (response.ok && responsePermissions.ok) {
          await AuthService.setCurrentUser(response.user);
          dispatch(privateActionCreators.loginSuccess({
            ...response.user,
            permissions: responsePermissions.data,
          }));
          dispatch(push(DEFAULT_PRIVATE_ROUTE));
          dispatch(toastActions.addToast({
            type: 'success',
            message: I18next.t('toast.account.welcome.message', { user: response.user.name }),
          }));
        } else {
          dispatch(privateActionCreators.loginFailure(I18next.t('account.errors.invalidCredentials')));
          dispatch(toastActions.addToast({
            type: 'error',
            message: I18next.t('toast.account.invalidCredentials.message'),
          }));
        }
      }
    };
  },
  logout() {
    return async (dispatch) => {
      dispatch({ type: actions.LOGOUT });
      await AuthService.removeCurrentUser();
      dispatch(push(DEFAULT_PUBLIC_ROUTE));
      dispatch({ type: actions.LOGOUT_END });
    };
  },
  register(params) {
    return async (dispatch) => {
      dispatch(privateActionCreators.registerStart());
      const response = await AuthService.register(params);
      if (response.ok) {
        dispatch(privateActionCreators.registerSuccess());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18next.t('screens.login.messages.success', params),
        }));
        const route = params.type === TYPE_MANUFACTURER ? MANUFACTURERS_HOME : VENDORS_HOME;
        dispatch(push(route));
      } else {
        dispatch(privateActionCreators.registerFailure(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: response.error,
        }));
      }
    };
  },
  recoverPassword(authData) {
    return async (dispatch) => {
      dispatch({ type: actions.RECOVER_PASSWORD });
      await AuthService.recoverPassword(authData);
    };
  },
  resetPassword(authData) {
    return async (dispatch) => {
      dispatch({ type: actions.RESET_PASSWORD });
      const response = await AuthService.resetPassword(authData);
      if (response.ok) {
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18next.t('toast.recoveryPassword.success'),
        }));
        dispatch(push(DEFAULT_PUBLIC_ROUTE));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18next.t('toast.recoveryPassword.failure'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Auth/actions.js